import '../configure-tests.scss';
import { Button, DataOptionType } from '@system1/lib-react';
import { ExistingQuestions } from 'components/configure-modals/configure-from-existing-questions/existing-questions/existing-questions';
import { ExistingQuestion as ExistingQuestionType } from 'components/configure-modals/configure-from-existing-questions/types';
import { ExistingQuestion } from 'components/configure-modals/configure-from-existing-questions/existing-questions/question/ExistingQuestion';

interface ConfigureFromExistingQuestionsProps {
  onClickNewQuestion: () => void;
  existingQuestions: ExistingQuestionType[];
  onSelect: () => void;
  closeModal: () => void;
  getAnswersById: (id: number) => Promise<any>;
  selectedQuestion: ExistingQuestionType;
  questionTemplatesOptions: DataOptionType[];
}

export const ConfigureFromExistingQuestions = ({
  onClickNewQuestion,
  existingQuestions,
  onSelect,
  closeModal,
  getAnswersById,
  selectedQuestion,
  questionTemplatesOptions,
}: ConfigureFromExistingQuestionsProps) => {
  return (
    <div className="configure-modal">
      <div className="configure-modal__left">
        <div className="configure-modal__header">
          <div className="configure-modal__header__icon" />
          Select from previous questions
        </div>

        {selectedQuestion && (
          <div className="configure-modal__selection">
            <div className="configure-modal__selection__label">
              Your selection:
            </div>
            <ExistingQuestion item={selectedQuestion} />
          </div>
        )}
        <div className="configure-modal__footer">
          <div className="configure-modal__footer__text">
            Define a new question instead?
          </div>
          <Button
            id="new_question"
            modifiers={['hollow', 'orange']}
            onClick={onClickNewQuestion}
          >
            New Question
          </Button>
        </div>
      </div>
      <div className="configure-modal__right">
        <ExistingQuestions
          closeModal={closeModal}
          existingQuestions={existingQuestions}
          getAnswersById={getAnswersById}
          onSelect={onSelect}
          selectedQuestion={selectedQuestion}
          questionTemplatesOptions={questionTemplatesOptions}
        />
      </div>
    </div>
  );
};
